module.exports = __webpack_public_path__ + "static/media/9.4a908a21.mp4";